import * as React from 'react'
import { getActiveSupplier } from '../lib/utils';
import { DataService } from '../services/DataService';
import Datalist, { ListColumn, FooterOptions } from '../components/Datalist/Datalist';
import { Contract } from '../services/API/Contracts';
import { t } from 'i18next';
type viewContract = {
    contractId:string;
    contractName:string;
    active:boolean;
}

        
const parseContractData = (contracts: Contract[]): viewContract[] => {
  const now = new Date();
  const threshold = 3;
  const reportDateThreshold = new Date(now);
  reportDateThreshold.setMonth(reportDateThreshold.getMonth() + threshold);
    const filterd = contracts.filter(x => !x.archived)
  return filterd.map((x) => {
    let active = false;
    if (x.archived !== true && x.reportingFromDate) {
      const reportingFromDate = new Date(x.reportingFromDate);

      if (reportingFromDate < reportDateThreshold) {
        if (x.reportingToDate) {
          active = now <= new Date(x.reportingToDate);
        } else if (x.terminationDate) {
          const terminationDatePlus96 = new Date(x.terminationDate);
          terminationDatePlus96.setMonth(terminationDatePlus96.getMonth() + 96);
          active = now < terminationDatePlus96;
        } else {
          active = true;
        }
      }
    }   
    return {
      contractId: x.contractId,
      contractName: x.contractName,
      active,
    };
  });
};
export const MyContracts = () => {
    const [isLoading,setIsLoading] = React.useState<boolean>(true);
    const [contracts,setContracts] = React.useState<viewContract[]>([]);
     React.useEffect(() => {
  let isMounted = true;
  const activeSupplier = getActiveSupplier();
  if (!activeSupplier) {
    setIsLoading(false);
    return;
  }

  const loadData = async () => {
    try {
      const [con] = await Promise.all([
        DataService.Contracts.GetBySupplierOrgNr(activeSupplier, false),
      ]);
      if (!isMounted) return;
      const result = parseContractData(con).sort((a, b) =>
        b.contractId.localeCompare(a.contractId, "sv", { numeric: true })
      );
      setContracts(result);
    } catch (err) {
      console.warn(err);
    } finally {
      if (isMounted) {
        setIsLoading(false);
      }
    }
  };
  loadData();
  return () => {
    isMounted = false;
  };
}, []);
      const columns : ListColumn<viewContract>[] = [
          {
            name: 'Ramavtalnummer',
            fieldName: "contractId",
            key: "contractId",
            minWidth: 50,
            maxWidth:50,
            isActive: true,
            sorting:true,
            isSortedDescending:true,
            footer: FooterOptions.COUNT
          },
          {
            name: t("contractListPage.list.name"),
            fieldName: "contractName",
            key: "contractName",
            minWidth: 100,
            maxWidth: 300,
            isActive: true,
            sorting: true,
            onRender(item, col) {
              return <div style={{textOverflow: "ellipsis", overflow: "hidden"}} title={item.contractName}>{item.contractName}</div>
            }
          },
          {
            name: "Aktivt",
            fieldName: "active",
            key: "active",
            minWidth: 50,
            maxWidth: 50,
            isActive: true,
            sorting: true,
            onRender(item, col) {
              return <div style={{textOverflow: "ellipsis", overflow: "hidden"}} >{item.active ? "Ja": "Nej"}</div>
            }
          }
        ]
    return(
        <>
        <div style={{height: "50vh"}}>
                  <Datalist 
                    uniqueKey='id'
                    items={contracts} 
                    columns={columns} 
                    setColumns={(cols) => console.log()} 
                    noItemsText={t("contractListPage.noItemsText")} 
                    initialSortKey='contractId'  
                    descendingSort={false}
                    isLoading={isLoading}
                  />
                </div>
        </>
    );
}